import firebase from '../services/firebase';
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';


export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return firebase.auth().currentUser ? (
          <>{children}</>
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        );
      }}
    />
  );
};